import React, { useEffect, useState } from 'react';
import Dashboard from '../../components/Dashboard';
import MainContainer from '../../components/containers/MainContainer';
import { GetRecordingUri } from '../../graphql/queries/GetRecordingUri';
import { useLazyQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';

const Recordings = () => {
    const [value, setValue] = useState(null);

    const { id } = useParams();

    const isValidId = id && id !== ':id';


    const [getCall] = useLazyQuery(GetRecordingUri, {
        variables: {
            callSid: id,
        },
        onCompleted(data) {
            if (data?.getRecordingUri?.__typename === 'CallActivityType') {
                const recordingUri = data?.getRecordingUri?.recordingUri;

                // Check if the URI ends with .json
                if (recordingUri?.endsWith('.json')) {
                    // If the URI ends with .json, prepend https://api.twilio.com and replace .json with .wav
                    const updatedUri = `https://api.twilio.com${recordingUri.replace('.json', '.wav')}`;
                    setValue(updatedUri);
                } else if (!recordingUri?.includes('.wav') && !recordingUri?.includes('.json')) {
                    // If the URI does not contain .wav or .json, append .wav
                    setValue(recordingUri + '.wav');
                } else {
                    // If the URI already contains .wav or .json, leave it as is
                    setValue(recordingUri);
                }
            }
        },
    });

    useEffect(() => {
        if (isValidId) {
            getCall();
        }
    }, [isValidId, getCall]);

    return (
        <Dashboard>
            <MainContainer bg='#e8e8e8' h='100vh'>
                <audio className='audio' controls src={value ?? ''} />
            </MainContainer>
        </Dashboard>
    );
};

export default Recordings;
